

import type { IBaseCMSPageContentViewModel } from './base-cms-page-content.viewModel.types';
import type { HTMLTagViewModel } from './html-tag-view-model/html-tag.viewModel';
import type { ICMSContentViewModel } from '../../types/cms-content.viewModel';
import type { CMSContentType } from '@/src/cms/domain/types/cms-content.types';
import type { LanguageMap } from '@/src/shared/utils/i18n';

export abstract class BaseCMSPageContentViewModel
implements IBaseCMSPageContentViewModel, ICMSContentViewModel
{
  abstract readonly $type: CMSContentType;

  title: string;

  htmlTags: HTMLTagViewModel[];

  hrefLang: LanguageMap<string>;

  canonicalUrl: string;

  metaTitle: string;

  metaDescription: string;

  ogTitle: string;

  ogDescription: string;

  ogUrl: string;

  twitterTitle: string;

  twitterDescription: string;

  twitterImageAlt: string;

  robots: string;

  constructor(data: IBaseCMSPageContentViewModel) {
    this.title = data.title;
    this.htmlTags = data.htmlTags;
    this.hrefLang = data.hrefLang;
    this.canonicalUrl = data.canonicalUrl;
    this.metaTitle = data.metaTitle;
    this.metaDescription = data.metaDescription;
    this.ogTitle = data.ogTitle;
    this.ogDescription = data.ogDescription;
    this.ogUrl = data.ogUrl;
    this.twitterTitle = data.twitterTitle;
    this.twitterDescription = data.twitterDescription;
    this.twitterImageAlt = data.twitterImageAlt;
    this.robots = data.robots || 'index, follow';
  }
}
